module.exports = __webpack_public_path__ + "img/phone_black_icon.334ac9cb.svg";